import { getHistoricalWeather } from "../server/OpenWeatherMap";
import { lStorage } from "../localStorage/lStorage";
import callback from "../prototypeDefinitions/Date.prototype.addDays";

callback();

const key = "analytics/weather";

const isSameDay = (date1, date2) =>
    !!(
        date1.getDay() === date2.getDay() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear()
    );

const saveDay = async (date) => {
    try {
        const rawData = await getHistoricalWeather(date);

        const getObj = (rawData, hour) => {
            const timeZoneOffset = 2;

            return {
                temp: Math.round(rawData.hourly[hour - timeZoneOffset].temp),
                descr: rawData.hourly[hour - timeZoneOffset].weather[0]
                    .description,
                wind: +rawData.hourly[hour - timeZoneOffset].wind_speed.toFixed(
                    1,
                ),
            };
        };

        const data = {
            date: date.getTime(),
            sunrice: rawData.current.sunrise * 1000,
            sunset: rawData.current.sunset * 1000,
            morningNigh: getObj(rawData, 4),
            morning: getObj(rawData, 9),
            noon: getObj(rawData, 13),
            evening: getObj(rawData, 18),
            eveningNight: getObj(rawData, 21),
        };

        const savedDays = (await lStorage.get(key)) ?? [];

        savedDays.push(data);

        await lStorage.set(key, savedDays);
    } catch {
        console.error("error");
    }
};

export const saveWeatherHistory = async () => {
    const savedDays = (await lStorage.get(key)) ?? [];

    const savedToday = savedDays.find((day) =>
        isSameDay(new Date(day.date), new Date()),
    );
    const savedYesterday = savedDays.find((day) =>
        isSameDay(new Date(day.date), new Date().addDays(-1)),
    );
    const savedBeforeYesterday = savedDays.find((day) =>
        isSameDay(new Date(day.date), new Date().addDays(-2)),
    );
    const savedBeforeBeforeYesterday = savedDays.find((day) =>
        isSameDay(new Date(day.date), new Date().addDays(-3)),
    );

    if (!savedToday) {
        const date = new Date();
        date.setMinutes(date.getMinutes() - 70);
        saveDay(date);
    }

    if (!savedYesterday) {
        const date = new Date().addDays(-1);
        saveDay(date);
    }

    if (!savedBeforeYesterday) {
        const date = new Date().addDays(-2);
        saveDay(date);
    }

    if (!savedBeforeBeforeYesterday) {
        const date = new Date().addDays(-3);
        saveDay(date);
    }
};
